module.exports = __webpack_public_path__ + "img/max-cloud-search.67cd8581.svg";